import React, { useState } from 'react';
import Popup from 'antd-mobile/es/components/popup';
import SearchBar from 'antd-mobile/es/components/search-bar';
import CheckList from 'antd-mobile/es/components/check-list';
import Input from 'antd-mobile/es/components/input';
import DotLoading from 'antd-mobile/es/components/loading';
import Empty from 'antd-mobile/es/components/empty';

import styles from './companyPopup.module.scss';
import { useOptions } from '../../hooks/useOptions';
import { useLanType, useTranslation } from '../../LangContext';
import PopupTitle from '../PopupTitle';

interface Props {
  value?: string;
  city: string;
  onChange?(val: string): void;
}

export const CompanyPopup = (props: Props) => {
  const [visible, setVisible] = useState(false);
  const { value, city, onChange } = props;

  const lanType = useLanType();
  const { options, onSearch, fetching } = useOptions({
    queryApi: 'queryBrandList',
    queryParams: { lanType, city },
    dependencies: [city, lanType],
    keywordsKey: 'brand',
  });

  const { t } = useTranslation();

  const brandPlaceholder = t('formConfig.brandPlaceholder');
  const notFoundContent = t('notFound.content');

  const onSelectItem = (val: Array<string>) => {
    onChange?.(val[0] || '');
    setVisible(false);
  };

  const renderList = () => {
    if (options.length > 0) {
      return (
        <CheckList onChange={onSelectItem}>
          {options.map((item, index) => {
            return (
              <CheckList.Item value={item.value} key={index}>
                {item.label}
              </CheckList.Item>
            );
          })}
        </CheckList>
      );
    }
    return (
      <Empty
        style={{ padding: '64px 0' }}
        imageStyle={{ width: 128 }}
        description={<div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: notFoundContent }} />}
      />
    );
  };
  return (
    <>
      <div onClick={() => setVisible(true)}>
        <Input placeholder={brandPlaceholder} value={value} readOnly />
      </div>
      <Popup
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
        forceRender
        destroyOnClose
        closeOnMaskClick
        style={{ '--z-index': '100001' }}
        bodyStyle={{ height: 'calc(100% - 8.75rem)', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
      >
        <PopupTitle onClose={() => setVisible(false)} title={t('formConfig.brandTitle')} />
        <div className={styles.container}>
          <div className={styles.searchBarContainer}>
            <div className={styles.searchBarLeft}>
              <SearchBar placeholder={brandPlaceholder} onChange={onSearch} />
            </div>
          </div>
          <div className={styles.options}>
            {fetching ? (
              <div className="flex justify-center align-middle">
                <DotLoading color="default" />
                <span> {t('fetchingTips')}</span>
              </div>
            ) : (
              renderList()
            )}
          </div>
        </div>
      </Popup>
    </>
  );
};
